<template>
  <div class="d-flex flex-column flex-root" v-if="isAuthenticated">
    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <Loader logo="media/imatge-corporativa/logoxupxup.png"></Loader>

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page " v-if="!loading">
      <div id="kt_wrapper" class="d-flex flex-column flex-row-fluid wrapper">
        <!-- begin:: Header -->
        <KTHeader></KTHeader>
        <!-- end:: Header -->

        <!-- begin:: Content -->
        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
        >
          <!-- begin:: Content Head -->

          <!-- begin:: Content Head -->
          <KTSubheader
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          />
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid">
            <div class="container-fluid" data-app>
              <transition name="fade-in-up">
                <router-view />
              </transition>
            </div>
          </div>
        </div>
        <KTFooter></KTFooter>
      </div>
    </div>
    <!-- <KTStickyToolbar v-if="toolbarDisplay"></KTStickyToolbar> -->
    <KTScrollTop></KTScrollTop>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import KTScrollTop from "@/view/layout/extras/ScrollTop";
import Loader from "@/view/content/Loader.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";
//import {VERIFY_AUTH} from "@/core/services/store/auth.module";
//import store from "@/core/services/store";

export default {
  name: "Layout",
  components: {
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    KTScrollTop,
    Loader
  },
  beforeCreate() {
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
    this.$store.dispatch("fetchAllPosts").then(() => {
     
      console.log("FETCH ALL LAYOUT");
      HtmlClass.init();
      // Simulate the delay page loading

      // Remove page loader after some time
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");

      //  resolve();
      //  });
      //this.$store.dispatch(VERIFY_AUTH).then(() => {

      // initialize html element classes
    });
  },
  created() {
    //console.log("Layout Auth", this.isAuthenticated,this.loading);
    if (!this.isAuthenticated) {
      this.$router.push({ name: "login" });
    }
    // show page loading
    //return new Promise(resolve => {
    console.log("After Promise Verify");
  },
  // mounted() {
  //
  // },
  methods: {},
  computed: {
    loading() {
      
      return this.$store.state.api.loading;
    },
    ...mapGetters([
      "isAuthenticated",
      "currentUser",
      "breadcrumbs",
      "pageTitle"
    ])
  }
};
</script>
